import * as React from 'react';
import { connect } from 'react-redux';
import { Button, Table, Row, Col } from 'reactstrap';
import { Translate, Storage } from 'react-jhipster';
import { toast } from 'react-toastify';

import { IRootState } from 'app/shared/reducers';
import { payByAsiaPaySuccess, payByAsiaPayFailure } from 'app/entities/payment/payment.reducer';
import { nowDateTime } from 'app/shared/util/date-utils';
import { RouteComponentProps } from 'react-router-dom';

export interface IAsiaPayResultProps extends StateProps, DispatchProps, RouteComponentProps<{ result: string }> {}

export interface IAsiaPayResultState {
  invoiceNo: string;
}

export class AsiaPayResult extends React.Component<IAsiaPayResultProps, IAsiaPayResultState> {
  state: IAsiaPayResultState = {
    invoiceNo: null
  };

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const transaction = Storage.session.get('TRANSACTION');
    const orderToken = Storage.session.get('ORDER_TOKEN');
    this.setState({ invoiceNo: transaction.invoiceNo });
    if (this.props.match.params.result && this.props.match.params.result.indexOf('success') >= 0) {
      this.props.payByAsiaPaySuccess(transaction.invoiceNo, orderToken ? orderToken.token : '');
    } else {
      this.props.payByAsiaPayFailure(transaction.invoiceNo, orderToken ? orderToken.token : '');
    }
    Storage.session.remove('ORDER_TOKEN');
    Storage.session.remove('SESSION');
    Storage.session.remove('TRANSACTION');
    Storage.session.remove('PI');
    Storage.session.remove('CART');
  }

  renderSuccess(invoiceNo) {
    if (invoiceNo) {
      return (
        <>
          <Row className="justify-content-center mt-4 mb-4">
            <Col md="6" className="text-center bg-primary">
              <h2 className="mt-3 mb-3 text-light">
                <Translate contentKey="order.paymentresult.success">付款成功!</Translate>
              </h2>
            </Col>
          </Row>
          <Row className="justify-content-center mt-4 mb-4">
            <Col md="6">
              <Table striped responsive>
                <tr>
                  <td>
                    <Translate contentKey="order.paymentresult.transactiontime">交易時間</Translate>:
                  </td>
                  <td>{nowDateTime()}</td>
                </tr>
                <tr>
                  <td>
                    <Translate contentKey="order.paymentresult.invoiceno">賬單號碼</Translate>:
                  </td>
                  <td>{invoiceNo}</td>
                </tr>
              </Table>
              <p className="text-center">
                <Translate contentKey="order.paymentresult.note1">
                  門票訂購已成功,閣下之郵箱將會收到確認訂單訊息,<br />請同時檢查雜件箱(Junk Mail),如24小時內仍未收到確認訂單訊息,<br />
                  歡迎電郵至 <a href="mailto:cs@patotix.com">cs@patotix.com</a> ,或致電客戶服務熱線{' '}
                  <a href="+85239080818">+852 5667 6376</a> 與我們聯絡。
                </Translate>
                <br />
                <br />
                <Button color="primary" href="/#/" size="xlg" className="mt-4">
                  <Translate contentKey="order.paymentresult.homebutton">返回首頁訂購其他門票</Translate>
                </Button>
              </p>
            </Col>
          </Row>
        </>
      );
    }
  }

  renderFailure(invoiceNo) {
    if (invoiceNo) {
      return (
        <>
          <Row className="justify-content-center mt-4 mb-4">
            <Col md="6" className="text-center bg-danger">
              <h2 className="mt-3 mb-3 text-light">
                <Translate contentKey="order.paymentresult.failed">付款失敗</Translate>
              </h2>
            </Col>
          </Row>
          <Row className="justify-content-center mt-4 mb-4">
            <Col md="6">
              <Table striped responsive>
                <tr>
                  <td>
                    <Translate contentKey="order.paymentresult.transactiontime">交易時間</Translate>:
                  </td>
                  <td>{nowDateTime()}</td>
                </tr>
                <tr>
                  <td>
                    <Translate contentKey="order.paymentresult.invoiceno">賬單號碼</Translate>:
                  </td>
                  <td>{invoiceNo}</td>
                </tr>
              </Table>
              <p className="text-center">
                <Translate contentKey="order.paymentresult.contactus">如有查詢，請致電聯絡我們。</Translate>
                <br />
                <br />
                <Button color="primary" href="/#/" size="xlg" className="mt-4">
                  <Translate contentKey="order.paymentresult.homebutton">返回首頁訂購其他門票</Translate>
                </Button>
              </p>
            </Col>
          </Row>
        </>
      );
    }
  }

  render() {
    toast.dismiss();
    const result = this.props.match.params.result;
    const invoiceNo = this.state.invoiceNo;
    return (
      <Row className="justify-content-center">
        <Col md="8" className="bg-white">
          <Row className="justify-content-center">
            <Col md="12" className="text-center">
              <h1 className="mt-3 mb-3">
                <Translate contentKey="order.paymentresult.status">交易狀況</Translate>
              </h1>
            </Col>
          </Row>
          {result === 'success' ? this.renderSuccess(invoiceNo) : this.renderFailure(invoiceNo)}
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (storeState: IRootState) => ({
  currentLocale: storeState.locale.currentLocale
});

const mapDispatchToProps = { payByAsiaPaySuccess, payByAsiaPayFailure };

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(AsiaPayResult);
